import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from '..';


export interface StripePaymentState {
    clientSecret: string | null;
    transactionRefId: string | null;
}

const initialState: StripePaymentState = {
    clientSecret: null,
    transactionRefId: null
};

export const stripePaymentSlice = createSlice({
    name: "stripePayment",
    initialState,
    reducers: {
        setPaymentDetail: (
            state,
            action: PayloadAction<{
                clientSecret: string | null;
                transactionRefId: string | null;
            }>
        ) => {
            state.clientSecret = action.payload?.clientSecret;
            state.transactionRefId = action.payload?.transactionRefId;
        },
        resetPaymentDetail: (state) => {
            state.clientSecret = null;
            state.transactionRefId = null;
            state = initialState;
        },
    },
});

export const { setPaymentDetail, resetPaymentDetail } = stripePaymentSlice.actions;
export const getClientSecret = (state: any) => state.stripePayment?.clientSecret;
export const getPaymentIntent = (state: any) => state.stripePayment?.transactionRefId;

export default stripePaymentSlice.reducer;
